import { isRelationManyValue } from '@varos/research-sdk-api';
import { assert } from '@varos/util-typescript';
import { useOutsideClick } from '@chakra-ui/react';
import React, { useContext, useState } from 'react';
import { ValueFieldContainerProps, ValueFieldViewProps } from './valueFieldProps';
import { ReportingContainerBaseConfig } from '../../../../base';
import { ValueFieldController } from './valueFieldInterface';
import { RelationOneValueContainerProps } from './relation/one';
import { RelationManyValueContainerProps } from './relation';

export function createValueFieldContainer(
    config: ReportingContainerBaseConfig & {
        Container: {
            Relation: {
                One: React.FC<RelationOneValueContainerProps>;
                Many: React.FC<RelationManyValueContainerProps>;
            };
        };
    },
    controller: ValueFieldController,
    View: React.FC<ValueFieldViewProps>
): React.FC<ValueFieldContainerProps> {
    const {
        context: { useContext },
        Container: {
            Relation: { One: RelationOneContainer, Many: RelationManyContainer },
        },
    } = config;

    return ({ ...containerProps }) => {
        if (
            containerProps.item.property.type === 'relation' &&
            containerProps.item.property.config.cardinality === 'one'
        ) {
            return <RelationOneContainer as={View} {...containerProps} />;
        }
        if (
            containerProps.item.property.type === 'relation' &&
            containerProps.item.property.config.cardinality === 'many'
        ) {
            assert(
                isRelationManyValue(containerProps.item.value),
                'expected relation many value'
            );
            return (
                <RelationManyContainer
                    as={View}
                    {...containerProps}
                    collection={containerProps.item.property.config.collection}
                    item={{
                        ...containerProps.item,
                        value: containerProps.item.value as string[],
                    }}
                />
            );
        }
        const context = useContext();
        const props = controller.useProps(context, containerProps.item, {
            value: {
                value: containerProps.item.value,
                onChange(value) {
                    containerProps.onChange(value);
                },
            },
            option: {
                onCreate(option) {
                    console.warn('creating option not supported yet', option);
                },
            },
        });
        return <View {...props} />;
    };
}
